export const COPIED_INVOICE_RELATION_FIELDS = [
  "relatedInvoiceListId",
  "relatedInvoiceListNumber",
  "relatedInvoiceListDate",
  "relatedInvoiceIds",
  "invoiceListId",
  "invoiceListNumber",
  "invoiceListDate",
  "relatedInvoiceId",
  "relatedInvoiceNumber",
  "relatedInvoiceDate",
  "relatedInvoiceProperty",
  "relatedInvoiceSerial",
  "relatedInvoiceType",
  "relatedTemplateCode",
  "hasRelatedInvoice",
] as const;

export const sanitizeCopiedInvoice = <T extends Record<string, any>>(
  invoice: T,
): T => {
  const sanitizedInvoice = { ...invoice };

  COPIED_INVOICE_RELATION_FIELDS.forEach((field) => {
    delete sanitizedInvoice[field];
  });

  return sanitizedInvoice;
};
